import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS } from "../../data/product";

export const FAQ = () => (
  <section id="faq" className="bg-[#FFFDF9] border-y border-[rgba(58,42,37,0.08)] scroll-mt-24" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-6 sm:px-10 py-20 sm:py-28">
      <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#C9A45C] mb-4">FAQ</p>
      <h2 className="font-serif-display font-medium text-4xl sm:text-5xl tracking-tight text-[#2B1F1B] mb-12">
        Questions, <span className="italic text-[#3A2A25]">answered.</span>
      </h2>
      <Accordion type="single" collapsible className="w-full">
        {FAQS.map((faq, i) => (
          <AccordionItem key={faq.q} value={`faq-${i}`} className="border-b border-[rgba(58,42,37,0.1)]" data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-left font-serif-display text-xl text-[#2B1F1B] hover:text-[#C9A45C] hover:no-underline py-6" data-testid={`faq-trigger-${i}`}>
              {faq.q}
            </AccordionTrigger>
            <AccordionContent className="text-base font-light leading-relaxed text-[#756A64] pb-6">
              {faq.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
